import { GameState } from '../objects/GameState';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Diagnosis } from '../objects/Diagnosis';
import { Helpers } from '../objects/Helpers';
import initializeInteractiveCursor from 'src/games/shared/InteractiveCursorUtil';
import TranslateApi from 'src/utils/TranslateHelper';

export class TestTubeInfoScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    correctDiagnosis: Diagnosis;

    constructor() {
        super({
            key: "TestTubeInfoScene_" + Math.random(),
        });
    }

    preload(): void {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("test_tube_info_scene_map", require("/src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_test_tube_info_scene.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'test_tube_info_scene_map' });
        this.correctDiagnosis = GameState.current.correctDiagnosis;
    }

    generateScene() {
        this.background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        this.background.setDisplaySize(this.gameWidth, this.gameHeight);
        this.background.setOrigin(0.5);
        this.background.setDepth(0);

        this.addObjects();
        Helpers.addNextButton(this);
        Helpers.addBackButton(this);
    }

    addObjects(): void {
        var fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
        var translateString = "Diagnosis.Phaser.TestTubeInfoScene.";
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = TranslateApi.translate(translateString + "text");
                var box = this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(this.gameWidth / 2 - box.displayWidth / 2);
                this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "tube_with_bubbles") {
                var tube1 = this.add.image(ob.x, ob.y, "assets", "test_tube_green");
                tube1.setOrigin(0);
                tube1.setDisplaySize(ob.width, ob.height);
                this.addReaction(tube1, "phaser_bubble");
            }
            else if (ob.name === "tube_with_flares") {
                var tube2 = this.add.image(ob.x, ob.y, "assets", "test_tube_purple");
                tube2.setOrigin(0);
                tube2.setDisplaySize(ob.width, ob.height);
                this.addReaction(tube2, "phaser_flare");
            }
        });
    }

    /**
     * Adds a "reaction" from the test tube using a particle emitter
     */
    addReaction(tube: Phaser.GameObjects.Image, reactionAsset: string): void {
        var reaction = this.add.particles("assets", reactionAsset);
        var emitter = reaction.createEmitter({
            x: tube.x + tube.displayWidth / 2,
            y: tube.getTopLeft().y,
            scale: { start: 0.3, end: 0.4 },
            angle: { min: 200, max: 330 },
            speed: 100,
            lifespan: 1200,
            blendMode: Phaser.BlendModes.SCREEN,
        });

    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/TestTubeInfoScene.ts